<div class="page-wrapper" [class.ntt-basecoat-legacy]="isLegacyRoute" [class.viewport-shell]="isViewportShell" [class.expand-side-menu]="isMenuOpen() && !loginPath">
  @if (!loginPath) {
    <ng-container>
      <lib-header></lib-header>
      @if (isMenuOpen()) {
        <app-side-menu />
      }
    </ng-container>
  }

  <div class="main-content">
    <router-outlet></router-outlet>
    <app-modern-host />
  </div>
</div>
